export enum StatusFinanceiro {
  Inadimplente = 'Inadimplente',
  EmDia = 'EmDia',
  Quitado = 'Quitado',
  AguardandoCartaoPagamentoRecorrente = 'AguardandoCartaoPagamentoRecorrente',
  RecorrenciaAgendada = 'RecorrenciaAgendada',
  Adimplente = 'Adimplente'
}

export enum StatusFinanceiroPorExtenso {
  Inadimplente = 'Inadimplente',
  EmDia = 'Em dia',
  Quitado = 'Quitado',
  AguardandoCartaoPagamentoRecorrente = 'Aguardando Cartão Pagamento Recorrente',
  RecorrenciaAgendada = 'Recorrência Agendada',
  Adimplente = 'Adimplente'
}
